// Loan-file upload rules shared by the file picker's `accept`, the drop zone's
// pre-check and its help text (ticket 80). The server enforces the same list
// (backend/rate_limits.py LOS_UPLOAD_ALLOWED_MIME) and returns the live cap +
// list from GET /api/los/uploads/policy; these constants are the fallback so
// the UI never shows nothing while that request is in flight.

export const DOC_EXTENSIONS = ['pdf', 'png', 'jpg', 'jpeg', 'webp', 'doc', 'docx', 'xlsx', 'csv', 'txt'];
export const DOC_ACCEPT = DOC_EXTENSIONS.map((e) => `.${e}`).join(',');
export const DEFAULT_MAX_MB = 25;

export const extensionOf = (name) => {
  const s = String(name || '');
  return s.includes('.') ? s.slice(s.lastIndexOf('.') + 1).toLowerCase() : '';
};

// Split a FileList into what the server will take and what it will reject,
// so the UI can say which files were dropped and why before uploading.
export function partitionFiles(fileList, { extensions = DOC_EXTENSIONS, maxMb = DEFAULT_MAX_MB } = {}) {
  const ok = [];
  const rejected = [];
  Array.from(fileList || []).forEach((f) => {
    const ext = extensionOf(f.name);
    if (!extensions.includes(ext)) rejected.push({ file: f, reason: `.${ext || '?'} is not an accepted type` });
    else if (f.size > maxMb * 1024 * 1024) rejected.push({ file: f, reason: `over ${maxMb} MB` });
    else ok.push(f);
  });
  return { ok, rejected };
}

export const describeAllowed = (extensions = DOC_EXTENSIONS, maxMb = DEFAULT_MAX_MB) =>
  `${extensions.map((e) => e.toUpperCase()).filter((e, i, a) => a.indexOf(e) === i && e !== 'JPEG').join(', ')} · up to ${maxMb} MB each`;
